import { type SvgProps, SvgWrapper } from '../utils';

export function CalendarViewDayIcon(props: SvgProps) {
  return (
    <SvgWrapper {...props}>
      <path d="M3 3.25L21 3.25C21.4142 3.25 21.75 3.58579 21.75 4C21.75 4.41421 21.4142 4.75 21 4.75L3 4.75C2.58579 4.75 2.25 4.41421 2.25 4C2.25 3.58579 2.58579 3.25 3 3.25Z" />
      <path d="M3 19.25L21 19.25C21.4142 19.25 21.75 19.5858 21.75 20C21.75 20.4142 21.4142 20.75 21 20.75H3C2.58579 20.75 2.25 20.4142 2.25 20C2.25 19.5858 2.58579 19.25 3 19.25Z" />
      <path d="M20.25 10C20.25 9.30964 19.6904 8.75 19 8.75H5C4.30964 8.75 3.75 9.30964 3.75 10V14C3.75 14.6904 4.30964 15.25 5 15.25H19C19.6904 15.25 20.25 14.6904 20.25 14V10ZM21.75 14C21.75 15.5188 20.5188 16.75 19 16.75H5C3.48122 16.75 2.25 15.5188 2.25 14V10C2.25 8.48122 3.48122 7.25 5 7.25H19C20.5188 7.25 21.75 8.48122 21.75 10V14Z" />
    </SvgWrapper>
  );
}
